export default __webpack_public_path__ + "static/media/logo_black.c421ba44.jpg";